module.exports = __webpack_public_path__ + "c66fe2bb7bd10c5949c70e9e1112500c.svg";